import * as React from "react";
import useMedia from "../../hooks/useMedia/useMedia";
import { Carousel } from "../Carousel/Carousel.web";
import type { Article } from "../data";
import { ArticleItem } from "./ArticleItem.web";
import { useStyles } from "./ArticleList.web.styles";

export const ArticleList: React.FC<{
  articles: Article[];
  id: string;
}> = ({ articles, id }) => {
  const styles = useStyles();
  const isDesktop = useMedia({ minWidth: "954px" });
  return (
    <div>
      {isDesktop ? (
        <div className={styles.root}>
          {articles.map((article) => {
            return <ArticleItem key={article.link} article={article} />;
          })}
        </div>
      ) : (
        <Carousel id={id}>
          {articles.map((article) => (
            <div key={article.title}>
              <div className={styles.carousel}>
                <ArticleItem key={article.link} article={article} />
              </div>
            </div>
          ))}
        </Carousel>
      )}
    </div>
  );
};
